// extracted by mini-css-extract-plugin
export default {"h4":"Pskxneg0","roboto":"XRvSiBpy"};